import { AUTHENTICATION_TYPE } from '../constants/auth.constants';

/**
 * Runs the unlock flow the server attached to a locked organization
 * (`organization.unlock`, built by `GET /organizations/available`). The client dispatches
 * on `unlock.type` and never derives the flow from the organization's auth method itself.
 * @param {object} deps
 * @param {(params: { authenticationMethodId, organizationId, loginHint }) => Promise<{ error?: string } | void>} deps.redirectToSSO
 * @param {(params: { organization, provider }) => Promise<{ error?: string } | void>} deps.unlockWithOauth
 * @param {(params: { organization, email }) => Promise<{ error?: string } | void>} deps.unlockWithOtp
 * @returns {(organization: object) => Promise<{ type: string, error?: string }>}
 */
export const unlockOrganizationWith =
  ({ redirectToSSO, unlockWithOauth, unlockWithOtp }) =>
  async organization => {
    const unlock = organization?.unlock;

    switch (unlock?.type) {
      case AUTHENTICATION_TYPE.SAML: {
        const { authenticationMethodId, organizationId, email } = unlock;
        const result = await redirectToSSO({
          authenticationMethodId,
          organizationId,
          loginHint: email,
        });
        return { type: unlock.type, ...result };
      }
      case AUTHENTICATION_TYPE.OAUTH: {
        const result = await unlockWithOauth({ organization, provider: unlock.provider });
        return { type: unlock.type, ...result };
      }
      case AUTHENTICATION_TYPE.OTP:
      default: {
        const result = await unlockWithOtp({ organization, email: unlock?.email });
        return { type: AUTHENTICATION_TYPE.OTP, ...result };
      }
    }
  };
